import { REHYDRATE } from "redux-persist";

import AuthenticationActionTypes from "services/authentication/types";
import AuthenticationUtils from "services/authentication/utils";
import UserActionTypes from "./types";

const initialState = {
  user: undefined,
  config: undefined,
  initialized: false,
};

const UserReducer = (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE:
      if (
        action.payload &&
        AuthenticationUtils.shouldPersistSession(action.payload.Authentication)
      ) {
        return state;
      }

      return initialState;
    case AuthenticationActionTypes.LOG_OUT:
      return initialState;
    case UserActionTypes.SET_USER:
      return {
        ...state,
        user: action.user,
        initialized: true,
      };
    default:
      return state;
  }
};

export default UserReducer;
